import React, { Component } from "react";
import { Redirect } from "react-router";
import { PrivacyPolicy } from "./PrivacyPolicy";
import { Button, Form, FormGroup, Input, Label, Spinner } from "reactstrap";
import { fetchJson } from "./shared/fetchJson";

export interface State {
  loading: boolean;
  agreed: boolean;
  redirect: boolean;
  exists: boolean;
}

export class TesterAgreement extends Component<{}, State> {
  constructor(props: {}) {
    super(props);

    this.state = {
      loading: true,
      agreed: false,
      redirect: false,
      exists: false,
    };

    this.submit = this.submit.bind(this);
  }

  async componentDidMount() {
    try {
      const r = await fetchJson<boolean>(`/api/user/exists`, {
        method: "GET",
      });
      this.setState({
        loading: false,
      });
      if (r) {
        this.setState({
          exists: r,
        });
      }
    } catch {
      this.setState({
        loading: false,
        exists: true,
      });
    }
  }

  submit(event: React.FormEvent) {
    event.preventDefault();
    if (this.state.agreed) {
      this.setState({ redirect: true });
    }
  }

  render() {
    const { loading, exists, redirect, agreed } = this.state;

    if (loading) {
      return <Spinner />;
    }
    if (exists) {
      return <Redirect to="/" />;
    }
    if (redirect) {
      return <Redirect to="/user/edit" />;
    }

    return (
      <>
        <div className="rounded px-3 px-sm-4 py-3 py-sm-5">
          <h1>Hey, you!</h1>
          <p>Thank you for joining us!</p>
        </div>
        <div
          className="rounded border overflow-auto p-3"
          style={{ maxHeight: 400 }}
        >
          <PrivacyPolicy />
        </div>
        <Form onSubmit={this.submit}>
          <FormGroup check className="pb-3 pt-3">
            <Label check>
              <Input
                type="checkbox"
                checked={agreed}
                onChange={() => {
                  this.setState({ agreed: !agreed });
                }}
              />{" "}
              I agree to the terms of service
            </Label>
          </FormGroup>
          <Button color="success" className="mb-3">
            Confirm
          </Button>
        </Form>
      </>
    );
  }
}
